export default __webpack_public_path__ + "static/media/Morph  Wolf Pict Warrior.49e42ae3.jpg";